import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ThemeSelector from '../ThemeSelector';
import { selectTheme } from '../../store/themeSlice';
import './Navbar.css';

function Navbar() {
  const currentTheme = useSelector(selectTheme);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleDropdown = (e) => {
    if (e) {
      e.stopPropagation();
    }
    setIsDropdownOpen(!isDropdownOpen);

    // Prevent body scroll when mobile menu is open
    if (isMobile) {
      document.body.style.overflow = !isDropdownOpen ? 'hidden' : '';
    }
  };

  // Close dropdown when clicking/touching outside
  const handleClickOutside = (e) => {
    if (!e.target.closest('.navbar-dropdown')) {
      setIsDropdownOpen(false);
      document.body.style.overflow = '';
    }
  };

  // Add event listeners when component mounts
  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    document.addEventListener('touchend', handleClickOutside);
    
    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('touchend', handleClickOutside);
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="navbar-brand">
          <Link to="/">POKéCOMP</Link>
        </div>
        <div className="right-content">
          <div className="navbar-links">
            <Link to="/database">Pokédex</Link>
            <Link to="/competitive">Competitive</Link>
            <Link to="/abilities">Abilities</Link>
            <Link to="/moves">Moves</Link>
            <Link to="/items">Items</Link>
            <Link to="/types">Charts</Link>
          </div>
          <ThemeSelector currentTheme={currentTheme} />
        </div>
      </div>
    </nav>
  );
}

export default Navbar; 